import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from '@app/components-fuse/layout/components/content/content.module';
import { FooterModule } from '@app/components-fuse/layout/components/footer/footer.module';
import { NavbarModule } from '@app/components-fuse/layout/components/navbar/navbar.module';
import { QuickPanelModule } from '@app/components-fuse/layout/components/quick-panel/quick-panel.module';
import { ToolbarModule } from '@app/components-fuse/layout/components/toolbar/toolbar.module';

import { VerticalLayout1Component } from '@app/components-fuse/layout/vertical/layout-1/layout-1.component';
import {LoadingDirectiveModule} from '../../../../../@shared/loading-directive/loading-directive.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
    declarations: [
        VerticalLayout1Component
    ],
  imports: [
    RouterModule,

    FuseSharedModule,
    FuseSidebarModule,

    ContentModule,
    FooterModule,
    NavbarModule,
    QuickPanelModule,
    ToolbarModule,
    LoadingDirectiveModule,
    TranslateModule,
    MatProgressSpinnerModule
  ],
    exports     : [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module
{
}
